import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/equipajeAntes.scss'
import Footer from '../Footer'

export default function Equipaje() {
  return (
    <>
    <section className="equipaje">
      <main className="equipaje__main">

      {/* HERO */}
      <div className='equipaje-hero'>
          <div className='overlay'></div>
          <div className='container hero-content'>
              <div style={{ marginTop: '4rem' }}>
                  <Breadcrumbs />
              </div>

              <h1>Información de Equipaje</h1>

              <p>
                  Conoce las condiciones y límites de equipaje para viajar de forma cómoda y segura. Consulta las dimensiones, peso permitido y recomendaciones para abordar sin contratiempos.
              </p>

          </div>

      </div>


        <div className="container">

          {/* Equipaje documentado */}
          <section className="equipaje__section">

            <div className="equipaje__section-title">
              <span className="material-symbols-outlined">luggage</span>
              <h2>Equipaje Documentado</h2>
            </div>

            <div className="equipaje__grid">

              {/* Card 1 */}
              <div className="equipaje__card bento-card">
                <span className="material-symbols-outlined icon-blue">
                  inventory_2
                </span>

                <h3>Piezas Permitidas</h3>

                <p className="equipaje__number">
                  Hasta 5 <span>piezas</span>
                </p>

                <p className="equipaje__text">
                  Por pasajero adulto, sujeto a disponibilidad de espacio en bodega.
                </p>
              </div>

              {/* Card 2 */}
              <div className="equipaje__card equipaje__card--large bento-card">

                <div className="equipaje__specs">

                  <div>
                    <div className="equipaje__label">
                      <span className="material-symbols-outlined">
                        scale
                      </span>

                      <h4>Peso Máximo</h4>
                    </div>

                    <p className="equipaje__number">
                      25 kg <span>por pieza</span>
                    </p>
                  </div>

                  <div>
                    <div className="equipaje__label">
                      <span className="material-symbols-outlined">
                        straighten
                      </span>

                      <h4>Dimensiones</h4>
                    </div>

                    <p className="equipaje__number">
                      158 cm <span>lineales en conjunto</span>
                    </p>
                  </div>

                </div>

                <div className="equipaje__warning">
                  <span className="material-symbols-outlined">
                    warning
                  </span>

                  <p>
                    Baja Ferries no se hace responsable por daños o roturas
                    si se excede el peso o dimensiones permitidas.
                  </p>
                </div>

              </div>

              {/* Card especial */}
              <div className="equipaje__card equipaje__card--primary bento-card">

                <div>
                  <span className="material-symbols-outlined big-icon">
                    <i class="fi fi-rs-wine-glass-crack"></i>
                  </span>

                  <h3>¿Equipaje Especial?</h3>

                  <p>
                    Si viajas con instrumentos, equipo deportivo o artículos
                    frágiles, indícalo durante tu proceso de check-in.
                  </p>
                </div>

              </div>

              {/* Prohibidos */}
              <div className="equipaje__card equipaje__card--danger bento-card">

                <h3 className="danger-title">
                  <span className="material-symbols-outlined">
                    block
                  </span>

                  Artículos Prohibidos
                </h3>

                <div className="equipaje__prohibited">

                  <div className="equipaje__item">
                    <div className="equipaje__item-icon">
                      <span className="material-symbols-outlined">
                        medication
                      </span>
                    </div>

                    <span>Drogas</span>
                  </div>

                  <div className="equipaje__item">
                    <div className="equipaje__item-icon">
                      <span className="material-symbols-outlined">
                        explosion
                      </span>
                    </div>

                    <span>Explosivos</span>
                  </div>

                  <div className="equipaje__item">
                    <div className="equipaje__item-icon">
                      <span className="material-symbols-outlined">
                        architecture
                      </span>
                    </div>

                    <span>Armas blancas</span>
                  </div>

                </div>

              </div>

            </div>
          </section>

          <hr className="equipaje__divider" />

          {/* Equipaje de mano */}
          <section className="equipaje__section">

            <div className="equipaje__section-title">
              <span className="material-symbols-outlined">work</span>
              <h2>Equipaje de Mano + Artículo Personal</h2>
            </div>

            <div className="equipaje__hand-grid">

              {/* Left */}
              <div className="equipaje__card equipaje__hand-main">

                <div className="equipaje__hand-content">

                  <div>
                    <h3>¿Qué incluye?</h3>

                    <ul>
                      <li>
                        <span className="material-symbols-outlined">
                          check_circle
                        </span>

                        Maleta de mano
                      </li>

                      <li>
                        <span className="material-symbols-outlined">
                          check_circle
                        </span>

                        Bolso o cartera
                      </li>

                      <li>
                        <span className="material-symbols-outlined">
                          check_circle
                        </span>

                        Mochila pequeña
                      </li>
                      <li>
                        <span className="material-symbols-outlined">
                          check_circle
                        </span>

                        Frazada ligera
                      </li>
                      
                    </ul>
                  </div>

                  <div className="equipaje__dimensions">

                    <div className="equipaje__dimensions-top">
                      <h4>Dimensiones Máx.</h4>

                      <span>10 KG</span>
                    </div>

                    <div className="equipaje__package-icon">
                      <span className="material-symbols-outlined">
                        package_2
                      </span>
                    </div>

                    <p className="size">55 x 40 x 25 cm</p>

                    <p className="subtitle">
                      Debe caber debajo de los asientos
                    </p>

                  </div>

                </div>

                <div className="equipaje__cabina-rule">

                  <span className="material-symbols-outlined">
                    bed
                  </span>

                  <div>
                    <h4>¿Reservaste cabina?</h4>

                    <p>
                      Solo se permite una maleta de 10 kg si viajas
                      en modalidad de cabina.
                    </p>
                  </div>

                </div>

              </div>

              {/* Right */}
              <div className="equipaje__card equipaje__restrictions">

                <h3>Restricciones</h3>

                <div className="equipaje__restriction-list">

                  <div className="equipaje__restriction">
                    <div>
                      <span className="material-symbols-outlined">
                        restaurant
                      </span>

                      <span>Alimentos y Bebidas</span>
                    </div>

                    <span className="material-symbols-outlined close">
                      close
                    </span>
                  </div>

                  <div className="equipaje__restriction">
                    <div>
                      <span className="material-symbols-outlined">
                        <i class="fi fi-rs-blanket"></i>
                      </span>

                      <span>Almohadas y Mantas</span>
                    </div>

                    <span className="material-symbols-outlined close">
                      close
                    </span>
                  </div>

                  <div className="equipaje__restriction">
                    <div>
                      <span className="material-symbols-outlined">
                        warning
                      </span>

                      <span>Drogas y Explosivos</span>
                    </div>

                    <span className="material-symbols-outlined close">
                      close
                    </span>
                  </div>

                  <div className="equipaje__restriction">
                    <div>
                      <span className="material-symbols-outlined">
                        hardware
                      </span>

                      <span>Armas Blancas</span>
                    </div>

                    <span className="material-symbols-outlined close">
                      close
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </section>

        </div>

      </main>
    </section>
    <Footer />
    </>
  )
}